module.exports = new __parcel__URL__("silver_pack_icon.e38b7d20.png").toString();